import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const UnAuthRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default UnAuthRoute;
